import "core-js/modules/es.array.push.js";
import appHead from "./imagetrans_head.vue";
import uploadImage from "./UploadAndCropSingleImage.vue";
import pixelArtList from "./pixelArtList.vue";
import pixelArtDetails from "./pixelArtDetails/index.vue";
// import blankBottom from "@/components/tiny/blankBottom.vue";
import appWidget from "@/components/widget/index.vue";
import { getLocalImagePath } from "@/lang/getLocalImg.js";
import { Product_Info } from "@/globalcfg.js";

//额外附加的数据(后台计算需要这些数据，前端并没使用)
const attachData = {
  scalewidth: 50,
  scaleheight: 50,
  width_chunk: 10,
  height_chunk: 10,
  imgcropbox: {
    left: 0,
    top: 0,
    width: 100,
    height: 100
  }
};
export default {
  name: "Upload",
  components: {
    appHead,
    uploadImage,
    pixelArtList,
    pixelArtDetails,
    // blankBottom,
    appWidget
  },
  emits: ["startBuild", "startcrop"],
  data() {
    return {
      uploading: false,
      showDetails: false,
      uploadUrl: '/imageprocesshost' + '/upload',
      //上传图片的接口
      createButImg: getLocalImagePath('imagetrans_upload_button'),
      //创建生成按钮
      assembleButImg: getLocalImagePath('imagetrans_assemble_button'),
      //开始拼装按钮
      currentDataList: [],
      //当前请求下来的数据列表
      currentEffectimg: null,
      //当前选中的效果图
      currentimgInfo: {
        id: "",
        likestatus: false,
        unlikestatus: false,
        ldrname: "",
        product_type: "",
        color_numbers: []
      },
      //当前选中的效果图的信息
      // particelImg: require("@/assets/doubleFaced/particle.png"), //颗粒图
      // particelImg: require("@/assets/public/white.png"), //颗粒图

      // shopUrl: "https://www.amazon.com/dp/B0CDLJRPNT",
      bottomshow: false,
      currentSeqdata: {
        color: []
      },
      //当前选中效果图对应的序列化数据

      origingimgbase64: null,
      //原始图片裁剪后的base64

      selectedParticleImg: null //选中的颗粒图
    };
  },

  props: {
    buildcontrol: {
      //拼装控制器
      type: Object,
      default: null
    },
    headImgUrl: {
      type: String,
      required: true
    },
    carousel_01: {
      type: String,
      required: true
    },
    carousel_02: {
      type: String,
      required: true
    },
    carousel_03: {
      type: String,
      required: true
    },
    carousel_04: {
      type: String,
      required: true
    },
    carousel_05: {
      type: String,
      required: true
    },
    carousel_06: {
      type: String,
      required: true
    },
    ex_original: {
      type: String,
      required: true
    },
    ex_target: {
      type: String,
      required: true
    },
    shopUrl: {
      type: String,
      required: true,
      default: "https://www.amazon.com/dp/B0CDLJRPNT"
    },
    product_type: {
      type: String,
      required: true
    },
    product_introduce: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$refs.imagetransfer.scrollIntoView();

    // 这里用path来判断选中的是哪个产品类型
    Object.keys(Product_Info).forEach((key, index) => {
      if (Product_Info[key].path == this.product_type) {
        this.selectedParticleImg = Product_Info[key].particle_img;
      }
    });
  },
  methods: {
    //点击使用指南
    handleGuide() {
      this.$router.push({
        path: 'guide'
      });
    },
    //上传数据之前
    onBeforeUpload() {
      this.uploading = true;
      this.showDetails = false;

      // 上传数据之前，清空当前数据列表, 这样可以完整显示loading
      if (this.currentDataList.length > 0) {
        this.currentDataList = [];
      }
    },
    //当上传数据成功
    onUploadSucceed(res) {
      // console.log("onUploadSucceed");
      // console.dir(res.res);

      let retdata = res.res;
      let origingimgbase64 = res.origingimgbase64;
      this.origingimgbase64 = origingimgbase64;

      // let rebuilimgs = await imgdataConvert(retdata, this.buildcontrol);
      let rebuilimgs = [];
      for (let i = 0; i < retdata.data.length; i++) {
        let item = 'data:image/jpg;base64,' + retdata.data[i].image_base64;
        let id = retdata.data[i].id;
        let ldrname = retdata.data[i].ldr;
        let color_numbers_dict = retdata.data[i].color_numbers;

        // 将color_numbers字典转换为数组
        let color_numbers = [];
        if (color_numbers_dict != undefined && color_numbers_dict != null && Object.keys(color_numbers_dict).length > 0) {
          // 将color_numbers字典转换为数组
          Object.keys(color_numbers_dict).forEach((key, index) => {
            let color = color_numbers_dict[key];
            color_numbers.push(color);
          });
        }
        let imgdata = {
          smallimg: item,
          likestatus: false,
          unlikestatus: false,
          id: id,
          ldrname: ldrname,
          color_numbers: color_numbers
        };
        rebuilimgs.push(imgdata);
      }
      this.currentDataList = rebuilimgs;

      // console.log("image tranfer currentDataList length:", this.currentDataList.length);
      // console.dir(this.currentDataList);
      // console.log("image tranfer particleImg:");
      // console.dir(this.selectedParticleImg);

      // 延时0.5秒，等待dom更新
      setTimeout(() => {}, 500);
      this.uploading = false;
      this.showDetails = true;
    },
    //上传图片失败
    onUploadFailed() {
      this.uploading = false;
    },
    //当选择不同的像素画
    onSelectedPixelArt(item) {
      // item 的数据结构
      // {
      //   product_type: this.product_type,
      //   data: this.dataList[index],
      // }

      // console.log("image tranfer onSelectedPixelArt, product_type:", this.product_type);
      // console.dir(item);

      let data = item.data;
      this.currentEffectimg = data.smallimg;
      this.currentimgInfo.id = data.id;
      this.currentimgInfo.likestatus = data.likestatus;
      this.currentimgInfo.unlikestatus = data.unlikestatus;
      this.currentimgInfo.ldrname = data.ldrname;
      this.currentimgInfo.product_type = this.product_type;
      this.currentimgInfo.color_numbers = data.color_numbers;

      // 滚动到pixelArtDetails 组件位置
      this.$refs.pixelArtDetails.onScrollIntoPixelartShow();
    },
    //点击喜欢
    onClicklike(imginfo) {
      this.currentimgInfo.id = imginfo.id;
      this.currentimgInfo.likestatus = imginfo.likestatus;
      this.currentimgInfo.unlikestatus = imginfo.unlikestatus;
      this.currentimgInfo.product_type = this.product_type;
      // currentDataList 需要更新，将当前选中的图片的like状态更新
      for (let i = 0; i < this.currentDataList.length; i++) {
        if (this.currentDataList[i].id == imginfo.id) {
          this.currentDataList[i].likestatus = imginfo.likestatus;
          this.currentDataList[i].unlikestatus = imginfo.unlikestatus;
          break;
        }
      }
    },
    //裁剪成功
    onCropOk(imgurl) {
      this.$refs.uploadImage.onCutOk(imgurl);
    },
    //裁剪取消
    onCropCancel() {
      this.$refs.uploadImage.onCutCancel();
    },
    //
    onStartcrop(imgurl) {
      this.$emit("startcrop", imgurl);
    },
    //显示缓存在浏览器的模型和裁剪图
    showLocalImage(originalImage, effectImg, seqdata) {
      this.$refs.uploadImage.showLocalImage(originalImage);
      this.currentEffectimg = effectImg;
      this.currentSeqdata = seqdata;
      this.origingimgbase64 = originalImage;
      this.showDetails = true;
    }
  }
};